import { AppLayout } from "../../components/layout/Header";
import AuditLogView from "../../components/messaging/AuditLogView";

export default function BrokerAudit() {
  return (
    <AppLayout variant="broker">
      <AuditLogView title="Broker Retention Log" />
    </AppLayout>
  );
}
